import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/shared/PageHeader';
import useSignalsData from './hooks/useSignalsData';
import BestPicksPage from './BestPicksPage';
import ScannerPage from './ScannerPage';
import SymbolDetailPage from './SymbolDetailPage';
import IndicatorAnalyticsPage from './IndicatorAnalyticsPage';

const TABS = [
  { path: '/signals', label: 'Best Picks', end: true },
  { path: '/signals/scanner', label: 'Scanner' },
  { path: '/signals/indicator/rsi', label: 'Indicator Analytics', match: '/signals/indicator' },
];

const TechnicalLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = useSignalsData();
  const isDetail = /^\/signals\/symbol\//.test(location.pathname);

  return (
    <div>
      <div className="hidden md:block">
        <PageHeader
          title="Technical Signals"
          description="Composite BUY / HOLD / SELL across every active stock and ETF — moving averages, MACD, RSI, Bollinger, Stochastic, ADX, OBV, Williams %R, Fibonacci, Pivots, S/R."
        />
      </div>

      {!isDetail && (
        <nav className="flex gap-2 border-b border-gray-200 dark:border-gray-800 mb-4 overflow-x-auto scrollbar-thin">
          {TABS.map((tab) => {
            const active = tab.end
              ? location.pathname === tab.path
              : location.pathname.startsWith(tab.match || tab.path);
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                className={`px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                  active
                    ? 'border-b-2 border-[#c9a96e] text-[#c9a96e]'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      )}

      <Routes>
        <Route index element={<BestPicksPage />} />
        <Route path="scanner" element={<ScannerPage data={data} />} />
        <Route path="symbol/:symbol" element={<SymbolDetailPage />} />
        <Route path="indicator/:name" element={<IndicatorAnalyticsPage />} />
      </Routes>
    </div>
  );
};

export default TechnicalLayout;
